import AsyncStorage from '@react-native-async-storage/async-storage'

const STORAGE_KEY = '@opportunity_users_display_map'

export type UsersDisplayMap = Record<string, string>

export const setUsersDisplayMap = async (users: { std_code: number; user_name: string }[]) => {
  try {
    const map: UsersDisplayMap = {}

    users.forEach((u) => {
      if (u?.std_code != null && u?.user_name) {
        map[String(u.std_code)] = u.user_name
      }
    })

    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(map))
  } catch (e) {
    // noop
  }
}

export const getUsersDisplayMap = async (): Promise<UsersDisplayMap> => {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY)

    if (!raw) return {}

    const parsed = JSON.parse(raw)

    return parsed && typeof parsed === 'object' ? (parsed as UsersDisplayMap) : {}
  } catch (e) {
    return {}
  }
}
